/* eslint-disable react/jsx-no-target-blank */
import React, {useEffect} from 'react'
import {useIntl} from 'react-intl'
import {KTIcon} from '../../../../helpers'
import {useAuth} from '../../../../../app/modules/auth'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'

const renderMenu = (item) => {
  if (item.url === '-') {
    return (
      <div key={item.id} className='menu-item'>
        <div className='menu-content pt-2 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
            {item.menu}
          </span>
        </div>
      </div>
    )
  }
  
  if (item.children && item.children.length > 0) {
    return (
      <SidebarMenuItemWithSub
        key={item.id}
        to={item.url}
        title={item.menu}
        icon={item.icon}
        hasBullet={item.parentId}
      >
        {item.children.map((child) => renderMenu(child))}
      </SidebarMenuItemWithSub>
    )
  }

  return (
    <SidebarMenuItem
      key={item.id}
      to={item.url}
      title={item.menu}
      icon={item.icon}
      hasBullet={item.parentId}
    />
  )
}

const SidebarMenuMain = () => {
  const intl = useIntl()
  const {menus} = useAuth()
  // useEffect(() => {
  //   console.log('Menus Updated:', menus)
  // }, [menus])
  return <>{menus && menus.map((m) => renderMenu(m))}</>
}

export {SidebarMenuMain}
